import * as React from 'react';
import { View, FlatList, TouchableOpacity } from 'react-native';
import Fonts from '../constants/Fonts';
import { Divider, Spinner, Text, Button } from 'native-base';
import { formatTweetText, formatTweetTime } from '../utils/TweetUtils';
import { ScreenStyles } from '../styles/AppStyles';
import LiveFeed from './LiveFeed';

type FeedListState = {
  tweets: Array<Object>,
  isLoading: boolean,
  limit: number,
  skip: number,
}

type FeedListProps = {
  onViewableItemsChanged: ({ viewableItems, changed }: any) => void;
}

class FeedList extends React.Component<FeedListProps, FeedListState> {
  flatListRef: any;
  constructor(props: any) {
    super(props)
    this.state = {
      tweets: [],
      isLoading: true,
      limit: 40,
      skip: 1,
    }
    this.flatListRef = React.createRef();
    this.nextPage = this.nextPage.bind(this);
  }

  componentDidMount() {
    this.getTweets();
    this.setState((state) => ({
      skip: state.skip + state.limit,
    }))
  }

  getTweets() {
    this.setState({ isLoading: true })
    fetch(`https://tweets.data-well.workers.dev/tweets-next?limit=${this.state.limit}&skip=${this.state.skip}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (this.state.tweets.length === 0) {
          this.setState({ tweets: data })
          this.setState({ isLoading: false })
          return
        }
        this.setState((state) => ({ tweets: [...state.tweets, ...data] }))
        this.setState({ isLoading: false })
        return

      })
  }

  nextPage() {
    const newSkip = this.state.skip + this.state.limit;
    this.setState((state) => ({
      skip: state.skip + state.limit,
    }))
    this.getTweets();
  }

  renderData = (tweet: any) => {
    let tweetText = formatTweetText(tweet.item.text)
    return (
      <View style={[ScreenStyles.containerCard, {borderColor: '#DDDDDD', borderBottomWidth: 1}]} data-date={formatTweetTime(tweet.item.createdAt)}>
        <Text style={[{ textAlign: 'right' }, Fonts.label]}>{formatTweetTime(tweet.item.createdAt)}</Text>
        <Text style={[{ textAlign: 'left', padding: 16 }, Fonts.p]}>{tweetText}</Text>
      </View>
    );
  };

  renderSpinner = () => {
    return <Spinner color='grey.500' size='lg' />;
  };

  tweetExtractorKey = (tweet: Object, index: number) => {
    return index.toString();
  };

  scrollToTop() {
    this.flatListRef.current.scrollToOffset({ animated: true, offset: 0 })
  }

  render() {
    return (
      <View
        style={{ flex: 1 }}
      >
        <FlatList
          onViewableItemsChanged={this.props.onViewableItemsChanged}
          ListHeaderComponent={<LiveFeed />}
          showsVerticalScrollIndicator={false}
          style={{ maxWidth: '100%' }}
          data={this.state.tweets && this.state.tweets.map((tweet: any) => tweet)}
          keyExtractor={this.tweetExtractorKey}
          renderItem={this.renderData}
          onEndReached={() => this.nextPage()}
          onEndReachedThreshold={0.5}
          ListFooterComponent={this.state.isLoading ? this.renderSpinner : null}
          ref={this.flatListRef}
          scrollsToTop
        />
        <Button style={{ backgroundColor:'#666666', position: 'absolute', bottom: 32, alignSelf: 'center', padding: 16, borderRadius: 100}} onPress={() => this.scrollToTop()}>
          Back To Top
        </Button>
      </View>
    );
  }
}


export default FeedList;